import { useContext, useEffect } from 'react';
import { DropDownUiItem } from './types';
import { RichEditUiRegistryContext } from './RichEditUiRegistryContext';

export type CustomDropDownProps = Omit<DropDownUiItem, 'type'> & {
  deps?: React.DependencyList;
};

/*
  Adds a dropdown to RichEdit's Ribbon tab and handles clicks on it`s options
 */
export const CustomDropDown = (props: CustomDropDownProps) => {
  const ctx = useContext(RichEditUiRegistryContext);

  useEffect(() => {
    if (!ctx) return;

    ctx.register({
      type: 'dropdown',
      ...props,
    });

    return () => ctx.unregister(props.id);
  }, props.deps || []);

  return null;
};
